<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <span>Pengumuman</span>
                </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Pengumuman</h2>
                <p class="page-subtitle">Pengumuman rasmi institusi</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-lg-10">

                    <!-- Carian -->
                    <div class="input-group mb-4">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fas fa-search"></i></span>
                        </div>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Cari pengumuman…"
                            v-model="search"
                            @keyup.enter="loadFeed"
                        />
                    </div>

                    <!-- Senarai pengumuman (kad) -->
                    <div class="row">
                        <div
                            class="col-12 col-md-6 col-lg-4 mb-4"
                            v-for="item in feed"
                            :key="item.id"
                        >
                            <div class="card h-100 announcement-card" @click="openDetail(item)">
                                <img
                                    v-if="item.cover_url"
                                    :src="item.cover_url"
                                    class="card-img-top announcement-cover"
                                    alt="cover"
                                />
                                <div v-else class="card-img-top announcement-cover announcement-cover-empty">
                                    <i class="fas fa-bullhorn"></i>
                                </div>
                                <div class="card-body">
                                    <h5 class="announcement-title">{{ item.title }}</h5>
                                    <p class="card-text text-muted">{{ item.summary }}</p>
                                </div>
                                <div class="card-footer bg-white border-0 d-flex justify-content-between align-items-center">
                                    <small class="text-muted">
                                        <i class="far fa-calendar-alt"></i> {{ item.start_at }}
                                    </small>
                                    <small class="text-muted">
                                        <span v-if="!item.is_read" class="badge badge-success mr-2">Baru</span>
                                        <i class="far fa-eye"></i> {{ item.read_count }}
                                    </small>
                                </div>
                            </div>
                        </div>

                        <!-- Keadaan kosong -->
                        <div v-if="!loading && feed.length === 0" class="col-12">
                            <div class="empty-state-sm">
                                <i class="fas fa-bullhorn"></i>
                                <p>Tiada pengumuman tersedia</p>
                            </div>
                        </div>
                    </div>

                    <!-- Pagination ringkas -->
                    <div v-if="meta.last_page > 1" class="d-flex justify-content-center mt-2">
                        <button
                            class="btn btn-outline-secondary btn-sm mr-2"
                            :disabled="meta.current_page <= 1"
                            @click="changePage(meta.current_page - 1)"
                        >
                            <i class="fas fa-chevron-left"></i> Sebelum
                        </button>
                        <span class="align-self-center mx-2">
                            {{ meta.current_page }} / {{ meta.last_page }}
                        </span>
                        <button
                            class="btn btn-outline-secondary btn-sm ml-2"
                            :disabled="meta.current_page >= meta.last_page"
                            @click="changePage(meta.current_page + 1)"
                        >
                            Seterusnya <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'AnnouncementFeed',
    data() {
        return {
            loading: false,
            search: '',
        }
    },
    computed: {
        ...mapState('announcement', ['feed', 'meta']),
    },
    mounted() {
        this.loadFeed()
    },
    watch: {
        search(newValue) {
            if (!newValue) {
                this.loadFeed()
            }
        },
    },
    methods: {
        async loadFeed(page) {
            this.loading = true
            this.$Progress.start()
            try {
                await this.$store.dispatch('announcement/fetchFeed', { q: this.search, page })
                this.$Progress.finish()
            } catch (error) {
                this.handleApiError(error)
            } finally {
                this.loading = false
            }
        },

        changePage(page) {
            this.loadFeed(page)
        },

        openDetail(item) {
            this.$router.push({ name: 'announcementDetail', params: { id: item.id } })
        },

        handleApiError(error) {
            this.$Progress.fail()
            if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                this.$store.dispatch('authentication/cencelAuthen')
            }
            // eslint-disable-next-line no-console
            console.log(error)
        },
    },
}
</script>

<style scoped>
.announcement-card {
    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.announcement-card:hover {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
}
.announcement-cover {
    height: 160px;
    object-fit: cover;
    background-color: #f1f1f1;
}
.announcement-cover-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2e7d32;
    color: rgba(255, 255, 255, 0.85);
    font-size: 2.5rem;
}
.announcement-title {
    color: #2c3e50;
    font-size: 1.05rem;
    font-weight: 700;
    margin-bottom: 8px;
    line-height: 1.3;
}
.card-text {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>
